import {
  getBuilderVersionErrorPayload,
  normalizeSnapshotVersionId,
} from '@/services/builderVersionErrors.ts';
import { getHttpErrorMessage } from '@/services/httpRetry.ts';
import { notifications } from '@mantine/notifications';

type StepMutationErrorDescriptor = {
  title: string;
  message: string;
  actualLatestVersionId: string | null | undefined;
  isLatestDraftConflict: boolean;
};

export function getStepMutationErrorDescriptor(
  operationLabel: string,
  error: unknown,
): StepMutationErrorDescriptor {
  const payload = getBuilderVersionErrorPayload(error);

  if (payload?.code === 'builder_snapshot_mismatch') {
    const actualLatestVersionId = normalizeSnapshotVersionId(payload.details.actual_latest_version_id);

    return {
      title: 'Latest draft changed',
      message: actualLatestVersionId
        ? 'The latest draft changed while the editor was open. Reload the editor and try again.'
        : 'This automation no longer has a latest draft. Reload the editor and try again.',
      actualLatestVersionId,
      isLatestDraftConflict: true,
    };
  }

  return {
    title: `Could not ${operationLabel}`,
    message: getHttpErrorMessage(error),
    actualLatestVersionId: undefined,
    isLatestDraftConflict: false,
  };
}

export function notifyStepMutationError(
  operationLabel: string,
  error: unknown,
  reportLatestDraftChanged: (latestVersionId: string | null) => void,
) {
  const errorDescriptor = getStepMutationErrorDescriptor(operationLabel, error);

  if (errorDescriptor.isLatestDraftConflict) {
    reportLatestDraftChanged(errorDescriptor.actualLatestVersionId ?? null);
  }

  notifications.show({
    title: errorDescriptor.title,
    message: errorDescriptor.message,
    color: 'red',
  });
}
